const JY_CONFIG = {
  'jytoken': [// 添加jytoken请求头的项目
    'magicCube'
  ],
  'tnt': [
    'magicCube'
  ],
  'customTips': [],
  'baseURL': {
    'magicCube': { // 魔方
        "https:": 'https://mcubeweb.xesv5.com',
        "http:" : 'http://mcubeweb.xesv5.com'
    } 
  }
}
export default JY_CONFIG



// WEBPACK FOOTER //
// ./common/assets/js/config.js